/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { FormControl, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import {
  format,
  isValid,
  isAfter,
  getYear,
  getMonth,
} from 'date-fns';
import IntlMsg from 'lorautils/intl/IntlMsg';
import MonthCalendar from '../MonthCalendar';
import styles from './styles.scss';

const FORMAT = {
  zh: 'YYYY-MM-DD HH:mm',
  en: 'DD/MM/YYYY HH:mm',
};
const kHours = ['00', '01', '02', '03', '04', '05', '06', '07',
  '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18',
  '19', '20', '21', '22', '23'];
const kMinite = ['00', '01', '02', '03', '04', '05', '06', '07',
  '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18',
  '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
  '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40',
  '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51',
  '52', '53', '54', '55', '56', '57', '58', '59'];

const defaultProps = {
  date: new Date(),
  view: 'date',
  closeOnSelect: true,
  disabled: d => isAfter(d, new Date()),
  anchor: null,
};

const propTypes = {
  intl: React.PropTypes.object.isRequired,
  date: React.PropTypes.instanceOf(Date),
  view: React.PropTypes.oneOf([
    'year',
    'month',
    'date',
  ]),
  onSelect: React.PropTypes.func.isRequired,
  locale: React.PropTypes.string.isRequired,
  disabled: React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.instanceOf(Date)),
    React.PropTypes.func,
  ]),
  closeOnSelect: React.PropTypes.bool,
  anchor: React.PropTypes.instanceOf(Date),
};

class DateTimePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: props.date,
      view: props.view,
      disabled: props.disabled,
      anchor: props.anchor,
      showDate: true,
      hour: !_.isNil(props.date) ? _.toString(format(props.date, 'HH')) : '00',
      minite: !_.isNil(props.date) ? _.toString(format(props.date, 'mm')) : '00',
    };
    this.intlMsg = new IntlMsg(props.intl, 'common.picker');
    this.id = `datepicker_${Number(Math.random() * 10000).toFixed(0)}`;
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.clickToBlur = this.clickToBlur.bind(this);
    this.inputChanged = false;
  }

  componentDidMount() {
    $('body').click(this.clickToBlur);
  }

  componentWillReceiveProps(nextProps) {
    const { date, view, disabled, anchor } = nextProps;
    if (date !== this.props.date) {
      let { hour, minite } = this.state;
      hour = _.toString(format(date, 'HH'));
      minite = _.toString(format(date, 'mm'));
      this.setState({ date, hour, minite });
    }
    if (view !== this.props.view) {
      this.setState({ view });
    }
    if (disabled !== this.props.disabled) {
      this.setState({ disabled });
    }
    if (anchor !== this.props.anchor) {
      this.setState({ anchor });
    }
  }

  componentWillUnmount() {
    $('body').off('click', this.clickToBlur);
  }

  clickToBlur(e) {
    let blurred = true;
    $(e.target).parents().each((idx, elem) => {
      if (elem.id === this.id) {
        blurred = false;
      }
    });
    if (blurred) {
      this.setState({
        showOverlay: false,
        showDate: true,
      });
    }
  }

  handleReturnDate(date = this.state.date) {
    const { hour, minite } = this.state;
    let newDate = format(date, 'YYYY-MM-DD');
    newDate = `${newDate} ${hour}:${minite}`;
    newDate = new Date(newDate);
    return newDate;
  }

  handleInputFocus() {
    this.setState({
      showOverlay: true,
    });
  }

  handleInputChange(e) {
    const value = e.target.value.trim();
    this.setState({ value });
    const date = new Date(value);
    if (isValid(date)) {
      this.inputChanged = true;
      this.setState({ date });
    }
  }

  handleInputBlur() {
    if (this.inputChanged) {
      const { onSelect } = this.props;
      const date = this.handleReturnDate();
      onSelect(date);
      this.inputChanged = false;
    }
  }

  handleSelect(date) {
    const { closeOnSelect } = this.props;
    const newDate = this.handleReturnDate(date);
    this.setState({ value: '', date: newDate });
    // const newDate = this.handleReturnDate(date);
    // onSelect(newDate);
    if (closeOnSelect) {
      this.setState({
        showOverlay: false,
        showDate: true,
      });
    }
  }

  handleComfire() {
    const { onSelect } = this.props;
    const date = this.handleReturnDate();
    onSelect(date);
    this.setState({
      showOverlay: false,
      showDate: true,
    });
  }

  renderView() {
    const { view = 'date', date, disabled, anchor } = this.state;

    if (view === 'date') {
      return (
        <MonthCalendar
          year={getYear(date)}
          month={getMonth(date)}
          selected={date}
          onSelect={this.handleSelect}
          disabled={disabled}
          anchor={anchor}
        />
      );
    }
    return null;
  }

  renderTime() {
    const { hour, minite } = this.state;
    return (
      <div className={styles.timeContent}>
        <div className={styles.timeList}>
          <ul>
            {_.map(kHours, h => (
              <li
                className={hour === h ? styles.selected : ''}
                onClick={() => this.setState({ hour: h })}
              >
                {h}
              </li>
            ))}
          </ul>
          <ul>
            {_.map(kMinite, m => (
              <li
                className={minite === m ? styles.selected : ''}
                onClick={() => this.setState({ minite: m })}
              >
                {m}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }

  renderOverlay() {
    const { showDate, showOverlay } = this.state;
    if (showOverlay) {
      return (
        <div className={styles.overlay}>
          {showDate &&
          <div className={styles.container}>
            {this.renderView()}
            <div className={styles.selectTime}>
              <a onClick={() => this.setState({ showDate: false })}>
                {this.intlMsg.msg('time')}
              </a>
              <Button
                bsStyle="aisz-primary"
                onClick={() => this.handleComfire()}
              >
                {this.intlMsg.msg('confirm')}
              </Button>
            </div>
          </div>}
          {!showDate &&
          <div className={styles.container}>
            {this.renderTime()}
            <div className={styles.selectTime}>
              <a onClick={() => this.setState({ showDate: true })}>
                {this.intlMsg.msg('date')}
              </a>
              <Button
                bsStyle="aisz-primary"
                onClick={() => this.handleComfire()}
              >
                {this.intlMsg.msg('confirm')}
              </Button>
            </div>
          </div>}
        </div>
      );
    }
    // return null;
    return <div style={{ minHeight: '300px', zIndex: 0, position: 'absolute' }} />;
  }

  render() {
    const { locale } = this.props;
    const { date, value = '' } = this.state;
    return (
      <div id={this.id} className={styles.datepicker}>
        <FormControl
          bsClass="aisz-form-control-f"
          type="text"
          placeholder={FORMAT[locale]}
          value={value || format(date, FORMAT[locale])}
          onFocus={this.handleInputFocus}
          onBlur={this.handleInputBlur}
          onChange={this.handleInputChange}
        />
        {this.renderOverlay()}
      </div>
    );
  }
}

DateTimePicker.propTypes = propTypes;
DateTimePicker.defaultProps = defaultProps;


const mapStateToProps = state => ({
  locale: state.intl.locale,
});
export default injectIntl(connect(mapStateToProps, null)(DateTimePicker));




// WEBPACK FOOTER //
// ./src/components/DateTimePicker/index.jsx